import { Reducer } from 'redux'
import { WAFRCreateAssessmentForm } from './action'

// Define the AWS Account ID structure
export interface AwsAccountIDs {
  id: string
  createdAt: string
  updatedAt: string
  awsAccountId: string
  role: string
  accountName: string
  sellerId: string
}

// Define the state shape
export interface AwsAccountState {
  awsAccountIds: AwsAccountIDs[]
}

// Initial state
const initialState: AwsAccountState = {
  awsAccountIds: [],
}

// Action types
type ActionType = {
  type: WAFRCreateAssessmentForm.ADD_AWS_ACCOUNT_IDS
  payload: AwsAccountIDs[]
}

// Reducer
export const reducer: Reducer<AwsAccountState, ActionType> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case WAFRCreateAssessmentForm.ADD_AWS_ACCOUNT_IDS: {
      return {
        ...state,
        awsAccountIds: action.payload, // Replaces the whole array
      }
    }

    default:
      return state
  }
}
